import React, { Component } from 'react';
import "./App.scss";
import dataJson from "../../static/api/data.json";

export default class App extends Component {
  render() {
    return (
      <div className="App">
        {dataJson.map((item, index) => <section key={index} className={`item item-${index}`}>
          <h2>
            {item.name}
          </h2>
          <ul>
            {item.options.map((obj, i) => <li key={i} className={`option option-${i}`}>
            <a href={obj.link} title={obj.name} target="_blank">{obj.name}</a>
            </li>)}
          </ul>
        </section>)}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/App/App.jsx